import * as XLSX from 'xlsx-js-style'

const text = element => element ? element.textContent.replace(/\s+/g, ' ').trim() : ''

const itemValues = item => [text(item.querySelector('label')), text(item.querySelector('span'))]

const safeFileName = value => String(value || '订单').replace(/[\\/:*?"<>|]/g, '_')

export function downloadOrderExcel(root, orderName) {
  if (!root) throw new Error('订单内容尚未加载')

  const table = root.querySelector('.el-table')
  const headers = table
    ? Array.from(table.querySelectorAll('.el-table__header-wrapper thead tr:last-child th:not(.gutter)')).map(text)
    : []
  const columnCount = Math.max(4, headers.length)
  const rows = []
  const rowKinds = []
  const merges = []

  const addRow = (values, kind = 'body') => {
    rows.push(values)
    rowKinds.push(kind)
    return rows.length - 1
  }
  const merge = (row, startColumn, endColumn) => {
    if (endColumn > startColumn) merges.push({ s: { r: row, c: startColumn }, e: { r: row, c: endColumn } })
  }
  const addFullRow = (value, kind) => {
    const row = addRow([value], kind)
    merge(row, 0, columnCount - 1)
  }
  const addInfoRow = (left, right) => {
    const half = Math.floor(columnCount / 2)
    const values = Array(columnCount).fill('')
    values[0] = left[0]
    values[1] = left[1]
    if (right) {
      values[half] = right[0]
      values[half + 1] = right[1]
    }
    const row = addRow(values, 'info')
    merge(row, 1, half - 1)
    if (right) merge(row, half + 1, columnCount - 1)
  }

  Array.from(root.querySelectorAll(':scope > .info-section:not(.no-print)')).forEach(section => {
    addFullRow(text(section.querySelector('.section-title')), 'section')

    const sectionTable = section.querySelector('.el-table')
    if (sectionTable) {
      addRow(headers, 'header')
      Array.from(sectionTable.querySelectorAll('.el-table__body-wrapper tbody tr')).forEach(tr => {
        addRow(Array.from(tr.querySelectorAll('td')).slice(0, headers.length).map(text))
      })
      const total = text(section.querySelector('.total-info'))
      if (total) addFullRow(total, 'total')
    } else {
      const blocks = Array.from(section.querySelectorAll('.unit-info-block'))
      if (blocks.length === 2) {
        addInfoRow([text(blocks[0].querySelector('.unit-title')), ''], [text(blocks[1].querySelector('.unit-title')), ''])
        const leftItems = Array.from(blocks[0].querySelectorAll('.info-item')).map(itemValues)
        const rightItems = Array.from(blocks[1].querySelectorAll('.info-item')).map(itemValues)
        for (let index = 0; index < Math.max(leftItems.length, rightItems.length); index += 1) {
          addInfoRow(leftItems[index] || ['', ''], rightItems[index])
        }
      } else {
        const items = Array.from(section.querySelectorAll('.info-item')).map(itemValues)
        for (let index = 0; index < items.length; index += 2) addInfoRow(items[index], items[index + 1])
        const emptyText = text(section.querySelector('.no-data'))
        if (!items.length && emptyText) addFullRow(emptyText, 'body')
      }
    }
    addFullRow('', 'blank')
  })

  const sheet = XLSX.utils.aoa_to_sheet(rows)
  sheet['!merges'] = merges
  sheet['!cols'] = Array.from({ length: columnCount }, (_, index) => ({ wch: index === 0 ? 16 : 18 }))
  sheet['!rows'] = rowKinds.map(kind => ({ hpt: kind === 'section' ? 25 : kind === 'blank' ? 8 : 22 }))

  const range = XLSX.utils.decode_range(sheet['!ref'])
  for (let row = range.s.r; row <= range.e.r; row += 1) {
    for (let column = range.s.c; column <= range.e.c; column += 1) {
      const cell = sheet[XLSX.utils.encode_cell({ r: row, c: column })]
      if (!cell) continue
      const kind = rowKinds[row]
      cell.s = {
        font: { name: '微软雅黑', sz: kind === 'section' ? 13 : 10, bold: ['section', 'header', 'total'].includes(kind) },
        fill: kind === 'section' ? { fgColor: { rgb: 'D9EAF7' } } : kind === 'header' ? { fgColor: { rgb: 'F2F2F2' } } : undefined,
        alignment: { vertical: 'center', horizontal: ['section', 'header'].includes(kind) ? 'center' : 'left', wrapText: true },
        border: kind === 'blank' ? undefined : {
          top: { style: 'thin', color: { rgb: 'BFBFBF' } },
          bottom: { style: 'thin', color: { rgb: 'BFBFBF' } },
          left: { style: 'thin', color: { rgb: 'BFBFBF' } },
          right: { style: 'thin', color: { rgb: 'BFBFBF' } }
        }
      }
    }
  }

  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, sheet, '订单')
  XLSX.writeFile(workbook, `${safeFileName(orderName)}.xlsx`, { compression: true, cellStyles: true })
}
